<script>
import checkPermission from "@/utils/permission";

import { mapGetters } from "vuex";

import { getOilInStockPage as getList } from "@/api/oil-in-stock";
import { getList as getStaffList } from "@/api/staff.js";

import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import { showPhoneAlarm } from "@/global/function.js";

import dayjs from "dayjs";

export default {
  components: { Header, Footer },
  filters: {
    formatTime(value) {
      if (!value) return value;
      return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  data() {
    const EDate = dayjs().format("YYYY/MM/DD");
    const dayTimeStamp = +dayjs().endOf("day");
    const beforeTimeStamp = +dayjs().startOf("month");
    const SDate = dayjs(beforeTimeStamp).format("YYYY/MM/DD");

    const listQuery = {
      limit: 10,
      page: 1,
      data: {
        isInteriorCode: undefined,
        isInteriorName: "全部",
      },
      date: {
        show: false,
        min: new Date(2020, 1, 1),
        max: new Date(2030, 12, 31),
        range: SDate + " - " + EDate,
        start: beforeTimeStamp,
        end: dayTimeStamp,
        default: [new Date(SDate), new Date(EDate)],
      },
    };

    const table = {
      listLoading: false,
      fullWidth: document.documentElement.clientWidth,
      key: 0,
      total: 0,
      data: [],
    };

    return {
      listQuery,
      staffList: [],
      table,
    };
  },
  computed: {
    ...mapGetters({
      userid: "user/userid",
    }),
    staffMap() {
      const map = this.staffList.reduce((acc, cur) => {
        acc[cur.username] = cur.name;
        return acc;
      }, {});
      map.anonymousUser = "系统";
      return map;
    },
  },
  created() {
    this.getListData();
    this.getStaffList();
  },
  methods: {
    checkPermission,
    clickLeft() {
      this.$router.go(-1);
    },
    getStaffList() {
      getStaffList({ limit: 1000, page: 1 }).then(({ data }) => {
        this.staffList = data.data.items;
      });
    },
    pickerDict(dictlist) {
      return dictlist.map((dict) => ({
        name: dict.label,
        value: dict.code,
      }));
    },
    getValue(list, value) {
      return list.find((dict) => dict.value === value) || {};
    },
    onStatusChoose(status) {
      const { value, name } = status;
      this.listQuery.data.isInteriorCode = value;
      this.listQuery.data.isInteriorName = name;
      this.showStatusPicker = false;
    },
    onRefuelChoose(refuel) {
      const { value, name } = refuel;
      this.listQuery.data.checkRefuel = value;
      this.listQuery.data.checkRefuelName = name;
      this.showRefuelPicker = false;
    },
    getStatus: function (value) {
      if (value === undefined) return "";
      return this.statusList.find((item) => +item.value === +value)?.name;
    },
    getRefuel: function (value) {
      if (value === undefined) return "";
      return this.refuelList.find((item) => +item.value === +value)?.name;
    },
    handleTableRowClick(row) {
      this.$refs.table.toggleRowExpansion(row);
    },
    async getListData() {
      const payload = {
        page: {
          current: this.listQuery.page,
          size: this.listQuery.limit,
        },
        where: {
          "desc_wwi.createTime": "1",
          "eq_wwi.hm": "柴油",
          "ge_wwi.gxsj": dayjs(this.listQuery.date.start)
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
          "le_wwi.gxsj": dayjs(this.listQuery.date.end)
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
        },
      };
      if (this.listQuery.sort) {
        let value = "";
        if (this.listQuery.sort === "ascending") value += "asc_wwi";
        if (this.listQuery.sort === "descending") value += "desc_wwi";
        if (value) {
          value += "." + this.listQuery.sortProp;
          payload.where[value] = 1;
        }
      }

      const response = await getList(payload).catch(() => false);
      if (response) {
        const { data } = response;
        if (
          showPhoneAlarm(
            false,
            "toast",
            null,
            2000,
            data.code,
            null,
            data.message
          )
        ) {
          this.table.total = data.page.total;
          this.table.data = data.page.records;
        }
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      return `${year}/${month + 1 > 9 ? month + 1 : "0" + (month + 1)}/${
        day > 9 ? day : "0" + day
      }`;
    },
    onConfirmDateChoose(date) {
      const [start, end] = date;
      this.listQuery.date.show = false;
      this.listQuery.date.range = `${this.formatDate(
        start
      )} - ${this.formatDate(end)}`;
      this.listQuery.date.start = new Date(start).getTime();
      this.listQuery.date.end = new Date(end).getTime();
    },
    openPreview(row) {
      const list = [];
      this.imgKey.forEach((key) => {
        if (row[key]) list.push(row[key]);
      });
      this.showPreview = true;
      this.showPreviewList = list;

      console.log("list", list);
    },
  },
};
</script>

<template>
  <div style="background: white">
    <Header
      :show="true"
      title="燃油入库记录"
      left="prepage"
      :click-left="clickLeft"
    />
    <div style="padding-bottom: 8vh">
      <!-- 顶部搜索相关 Cell -->
      <div>
        <van-cell
          :value="listQuery.date.range"
          is-link
          @click="listQuery.date.show = true"
        >
          <template #title>
            <span style="font-size: 2vh">时间区间</span>
          </template>
        </van-cell>
        <van-calendar
          v-model="listQuery.date.show"
          type="range"
          :min-date="listQuery.date.min"
          :max-date="listQuery.date.max"
          :default-date="listQuery.date.default"
          color="#ee0a24"
          :style="{ 'padding-bottom': '30px' }"
          @confirm="onConfirmDateChoose"
        />
        <div style="margin: 8px">
          <van-button
            v-if="checkPermission([481])"
            round
            block
            type="info"
            @click="getListData"
          >
            查询
          </van-button>
        </div>
      </div>
      <el-table
        ref="table"
        :data="table.data"
        style="width: 100%"
        size="small"
        @row-click="handleTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
        >
          <template slot-scope="{ row }">
            <el-form
              label-position="left"
              label-width="100px"
              :show-message="false"
              style="padding: 0 20px"
              class="tableExpressInfo"
            >
              <el-form-item label="流水号：">
                <span>{{ row.lsh }} 吨</span>
              </el-form-item>
              <el-form-item label="入库时间：">
                <span>{{ row.gxsj | formatTime }}</span>
              </el-form-item>
              <el-form-item label="车牌号：">
                <span>{{ row.ch }}</span>
              </el-form-item>
              <el-form-item label="供应商：">
                <span>{{ row.fhdw }}</span>
              </el-form-item>
              <el-form-item label="入库重量：">
                <span>{{ row.sz }} 吨</span>
              </el-form-item>
              <el-form-item label="入库数量：">
                <span>{{ row.rksl }} L</span>
              </el-form-item>
              <el-form-item label="记录人：">
                <span>{{ staffMap[row.mzsby] || row.mzsby }}</span>
              </el-form-item>
              <el-form-item label="备注：">
                <span>{{ row.bz }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          align="center"
          width="70"
        />
        <el-table-column
          label="流水号"
          prop="lsh"
          align="center"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          label="入库重量（吨）"
          prop="sz"
          align="center"
          min-width="120"
          show-overflow-tooltip
        />
      </el-table>
      <el-pagination
        v-show="table.total > 0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        style="margin: 0.6rem 0; text-align: center"
        @current-change="getListData"
      />
    </div>
    <Footer value="service" />
  </div>
</template>

<style scoped>
.tableExpressInfo .el-form-item {
  margin-bottom: 0 !important;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
</style>